import React, { useContext, useEffect, useState } from 'react';
import ListFriendChat from '../../components/list-friend-chat/list-friend-chat.component';
import { IFriend } from '../../types/friend';
import ChatDetail from '../../components/chat-detail/chat-detail.component';
import { SignalRContext } from '../../context/signalR';
import { IChat, SendMessagePayload } from '../../types/chat';
import { HubEvent } from '../../enums/hubnames';
import { useFriend } from '../../hooks/use-friend/useFriend';
import { useNavigate } from 'react-router-dom';

export const ChatPage = () => {
  const {
    state: { connectionChat },
  } = useContext(SignalRContext);

  const [currentChat, setCurrentChat] = useState<IFriend | null>(null);
  const [newMessage, setNewMessage] = useState<IChat | null>(null);
  const [listNewMessage, setListNewMessage] = useState<IChat[]>([]);
  const navigate = useNavigate();
  const { data } = useFriend({ pageSize: 100 });
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userId = params.get('id');

    if (userId && data.length > 0) {
      const defaultUser = data.find((friend) => friend.userId === userId);
      if (defaultUser) {
        setCurrentChat(defaultUser);
      }
    }
  }, [location.search, data]);

  const handleSendMessage = (payload: SendMessagePayload) => {
    connectionChat?.invoke('SendMessage', payload);
  };

  useEffect(() => {
    connectionChat?.on(HubEvent.NewMessage, (message: IChat) => {
      setNewMessage(message);
      setListNewMessage([message]);
      setListNewMessage((prev) => {
        if (newMessage) {
          return [newMessage, ...(prev ?? [])];
        }

        return prev;
      });
    });
  }, [connectionChat]);

  return (
    <div className=" relative overflow-hidden dark:border-slate-700">
      <div className="flex bg-white dark:bg-dark2">
        <ListFriendChat
          onSelect={(friend) => {
            const params = new URLSearchParams(location.search);
            params.set('id', friend.userId);
            navigate(`?${params.toString()}`, { replace: true });
            setCurrentChat(friend);
          }}
          currentChat={currentChat}
          listNewMessage={listNewMessage}
        />

        <div className="flex-1 h-[calc(100vh-76px)]  px-6 py-6">
          {currentChat ? (
            <div className="border h-full rounded-lg">
              <ChatDetail
                user={currentChat}
                handleSendMessage={handleSendMessage}
                newMessage={newMessage}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center mt-10">
              <p className="text-sm text-slate-800 dark:text-slate-50">
                Chọn người để bắt đầu cuộc trò chuyện
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
